// extracted by mini-css-extract-plugin
module.exports = {"home":"_1Gr1XXAn","box":"_2QOZIcwt","logo":"_2xUlpjGt","title":"_2rbFlgJS","title-label":"_331iF6iD","is-disabled":"_2Deba-rw","is-enabled":"_3G7iKb4Y","form-actions":"_3td8Ruvv"};